var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-menu-container",
      attrs: { id: "perspective-first-sidebar-menu" }
    },
    [
      _c("div", { staticClass: "sidebar-main-label" }, [
        _vm._v("Задание перспективы")
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-step-two-img-container" }, [
        _c("img", {
          staticClass: "sidebar-step-two-img",
          attrs: { src: _vm.urlForStatic("/img/perspective_plane.png") }
        })
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-text-area" }, [
      _vm._v("Для начала работы выберите на рабочей области\n        "),
      _c("span", { staticClass: "red-text bold-text" }, [_vm._v("плоскость")]),
      _vm._v(
        " для настройки. Чтобы приступить к заданию линий перспективы плоскости, воспользуйтесь кнопкой\n    "
      ),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v('"Настроить перспективу"')
      ]),
      _vm._v(" на нижней панели.")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-text-area" }, [
      _vm._v(
        "\n        Альтернативно, Вы можете быстро перейти к настройкам перспективы, выбрав плоскость "
      ),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v("двойным кликом")
      ]),
      _vm._v(".\n    ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }